exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".created[data-v-0029ffe8] {\n  text-transform: uppercase;\n}", ""]);

// exports
